import { useAppSelector } from '@/redux/hooks';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { selectUserPreferences } from '@/redux/selectors/authSelectors';
import { FilterLayoutsFilter } from '@/redux/slices/slice_types';

export const useSavedFilterSettings = () => {
  const tableKey = useAppSelector(selectCurrentTableKey);
  const userPrefs = useAppSelector(selectUserPreferences);
  const userFilterLayouts: FilterLayoutsFilter[] | undefined = tableKey ? userPrefs[tableKey]?.filters : undefined;

  return userFilterLayouts;
};
